/*
 * Copyright © 2023-2024 www.4bex.com
 *
 * Licensed under the www.4bex.com License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.4bex.com/license
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from "react";
import { Modal, Skeleton } from "antd";
import { Form, Input, Row, Col } from "antd";
import "./ViewBankDetailsModal.css";
import { useQuery } from "@tanstack/react-query";
import { getBookingTransactionsByUserId } from "../../../../common/api/transaction";

const ViewBankDetailsModal = ({ transaction, visible, onClose }) => {
   const { user_id } = transaction;

   const payoutQuery = useQuery({
      queryKey: ["payout", "user", user_id],
      queryFn: () => getBookingTransactionsByUserId(user_id),
      staleTime: 1000 * 60 * 15, // 15 minutes
   });

   const fullData = payoutQuery.data?.data?.success.data;
   const details = fullData?.length ? fullData[0] : null;

   return (
      <Modal
         title="Bank Details"
         open={visible}
         onCancel={onClose}
         footer={null}
         width={800}
      >
         {payoutQuery.isLoading || !details ? (
            <Skeleton active />
         ) : (
            <Form layout="vertical">
               <Row gutter={16}>
                  <Col span={12}>
                     <Form.Item label="Bank Name">
                        <Input value={details.bank_name || "N/A"} readOnly />
                     </Form.Item>
                  </Col>
                  <Col span={12}>
                     <Form.Item label="Account Number">
                        <Input value={details.account_number || "N/A"} readOnly />
                     </Form.Item>
                  </Col>
               </Row>
               <Row gutter={16}>
                  <Col span={12}>
                     <Form.Item label="Account Holder Name">
                        <Input value={details.account_holder_name || "N/A"} readOnly />
                     </Form.Item>
                  </Col>
                  <Col span={12}>
                     <Form.Item label="User Name">
                        <Input value={details.user_name || "N/A"} readOnly />
                     </Form.Item>
                  </Col>
               </Row>
            </Form>
         )}
      </Modal>
   );
};

export default ViewBankDetailsModal;
